import Dexie from 'dexie'

let Db = new Dexie("se-main-mx-vueadmin")

Db.version(1).stores({
	configs: 'key,value'
})

export default Db
